/**
 * daddl-judge-me.js
 * -----------------------------------------------------------------------------
 * Compact Judge.me helpers (no DOM hiding, no extra headings):
 *   1. Keep daddl-judge-me.css after Judge.me injects its own <style>.
 *   2. Featured-collection badges: "59 reviews" → "(59)" if Admin text is still wordy.
 *
 * Loaded from snippets/daddl-judge-me.liquid.
 * Do not hide “other languages” or inject a title — that emptied the list
 * and duplicated “Reviews”. Language split is Settings → Language in Admin.
 * -----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var CSS_ID = 'daddl-judge-me-css';
  var patchTimer = 0;

  function sheetLink() {
    var link = document.getElementById(CSS_ID);
    if (link) return link;
    link = document.querySelector('link[href*="daddl-judge-me"]');
    if (link) link.id = CSS_ID;
    return link;
  }

  /** Move our stylesheet after Judge.me-injected rules so cascade order wins. */
  function bumpStylesheet() {
    var link = sheetLink();
    if (link && link.parentNode) document.body.appendChild(link);
  }

  /** Product cards: stars then (59), not “4.8 (59 reviews)” on a second line. */
  function formatCardBadgeCounts() {
    document.querySelectorAll('.daddl-fc__stars .jdgm-prev-badge__text, .card-wrapper .jdgm-prev-badge__text').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (/^\(\d+\)$/.test(t)) return;
      var paren = t.match(/\((\d+)\)/);
      if (paren) {
        el.textContent = '(' + paren[1] + ')';
        return;
      }
      var nums = t.match(/\d+/g);
      if (nums) el.textContent = '(' + nums[nums.length - 1] + ')';
    });
  }

  /** Remove leftover headings from the previous inject (one refresh). */
  function stripInjectedHeadings() {
    document.querySelectorAll('.daddl-judge-me__heading').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
  }

  function schedulePatch() {
    if (patchTimer) window.clearTimeout(patchTimer);
    patchTimer = window.setTimeout(function () {
      bumpStylesheet();
      stripInjectedHeadings();
      formatCardBadgeCounts();
    }, 50);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j += 1) {
        var node = added[j];
        if (node.nodeName === 'STYLE') {
          var text = node.textContent || '';
          if (text.indexOf('jdgm') > -1 || text.indexOf('jm-') > -1) {
            schedulePatch();
            return;
          }
        }
        if (node.nodeType !== 1) continue;
        if (
          (node.classList &&
            (node.classList.contains('jm-review-widget') ||
              node.classList.contains('jdgm-rev-widg') ||
              node.classList.contains('jdgm-prev-badge') ||
              node.classList.contains('jdgm-preview-badge'))) ||
          (node.querySelector &&
            node.querySelector(
              '.jm-review-widget, .jdgm-rev-widg, .jdgm-prev-badge__text'
            ))
        ) {
          schedulePatch();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  schedulePatch();
  window.setTimeout(schedulePatch, 1500);
})();
